<template>
  <div>
    <v-icon v-if="notificationsEnabled">{{ mdiBell }}</v-icon>
    <v-icon v-else>{{ mdiBellOff }}</v-icon>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiBell, mdiBellOff } from '@mdi/js';
import {
  // ActionPerformed,
  // PushNotificationSchema,
  PushNotifications,
  // Token,
} from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';

export default {
  data() {
    return {
      notificationsEnabled: false,
      mdiBell,
      mdiBellOff,
    };
  },
  computed: {
    ...mapState('userNotification', ['userNotification']),
  },
  async created() {
    const isEnable = await LocalNotifications.checkPermissions();
    if (!isEnable) {
      await LocalNotifications.requestPermission();
    }
    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermissions().then(async (result) => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
        this.notificationsEnabled = true;
      } else {
        this.notificationsEnabled = false;
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      async (token) => {
        // upload token to the server
        await this.LOAD_userNotification();
        const { userNotification } = this;
        userNotification.token = token.value;
        this.$log.info('android token received');
        await this.UPDATE_userNotification(userNotification);
        this.$log.info('android token uploaded');
        await this.subscribeToArticles(token.value);
        this.$log.info('subscribed to articles');
      });

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error) => {
        this.$log.error(error);
      });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      async (notification) => {
        this.$log.debug(notification);
        // alert(JSON.stringify(notification));
        const { title, body, id } = notification;
        const result = await LocalNotifications.schedule({
          notifications: [
            {
              title,
              body,
              id,
              iconColor: '#518fc8',
              largeIcon: 'icon',
              vibration: true,
            },
          ],
        });
        // logs the notifcations
        this.$log.info(result);
        // alert(JSON.stringify(result));
      });

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification) => {
        this.$log.info(`Push action performed: ${JSON.stringify(notification)}`);
      });
  },
  methods: {
    ...mapActions('userNotification', ['LOAD_userNotification', 'UPDATE_userNotification']),
    ...mapActions('articles', ['subscribeToArticles']),
    async test() {
      const notifs = await LocalNotifications.schedule({
        notifications: [
          {
            title: 'Suidlanders',
            body: 'Notifications are working correctly',
            id: 1,
            iconColor: '#518fc8',
            largeIcon: 'icon',
            vibration: true,
          },
        ],
      });
      // logs the notifcations
      // alert(JSON.stringify(notifs));
      this.$log.info(notifs);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
